import { render, staticRenderFns } from "./UserGroupMap.vue?vue&type=template&id=3339898f&"
import script from "./UserGroupMap.vue?vue&type=script&lang=js&"
export * from "./UserGroupMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports